export const styles = {
  wrapper: {
    padding: '0px 90px 0px 44px',
  },

  container: {
    position: 'relative',
    minHeight: 40,
    display: 'flex',
    flexWrap: 'wrap',
    '& .SearchAndFilters-filterGroup': {
      display: 'inline-block',
      marginRight: 35,
      marginBottom: 20,
      textAlign: 'left',
    },
  },
  searchContainer: {
    marginBottom: 20,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
  },
  searchBox: {
    backgroundColor: 'white',
    border: '1px solid #dfe2e5',
  },
  presets: {
    marginLeft: '10px',
  },
  formControl: {
    '& .MuiFormControl-root': {
      margin: 8,
      minWidth: 118,
      marginRight: 60,
    },
  },
}
